import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../../app/redux/hooks";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { ProductTypes } from "../../../public/landingPage/components/productTypes";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import { Footer } from "../../../../layouts/footer";

export const OrderConfirmationFailed = () => {
  const navigate = useNavigate();
  return (
    <>
      <ResponsiveAppBar />
      <ProductTypes />
      <section className="flat-spacing-14 mt-5">
        <div
          className="container"
          style={{
            fontFamily: "Albert Sans, sans-serif",
            fontSize: "14px",
            lineHeight: "22px",
            fontWeight: "400",
          }}
        >
          <div className="row align-items-center justify-content-center">
            <div className="col-md-8">
              <div className="mb-3 error-bg">
                <div className="row align-items-center justify-content-center ">
                  <div className="col-12 text-center">
                    <img
                      src="images/payments/payment-fail.svg"
                      width="50"
                      alt=""
                    />
                    <h6 className="my-2 fw-6">Your Payment has Failed !</h6>
                    <p className="address-text">
                      Our Team is Reviewing your request.
                      <br />
                      You will hear from us shortly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
